import {Component, effect, inject, OnInit, output} from '@angular/core'
import {FormControl, ReactiveFormsModule, Validators} from '@angular/forms'
import {MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle} from '@angular/material/expansion'
import {MatRadioButton, MatRadioChange, MatRadioGroup} from '@angular/material/radio'
import {getTakeUntilDestroyed} from '@sparbanken-syd/sparbanken-syd-theme'
import {Plural} from '../../model/plural'
import {ControlService} from '../../services/control.service'

@Component({
  selector: 'spb-follow-advice',
  templateUrl: './follow-advice.component.html',
  styleUrls: ['./follow-advice.component.scss'],
  imports: [
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatRadioGroup,
    ReactiveFormsModule,
    MatRadioButton
  ]
})
export class FollowAdviceComponent extends Plural implements OnInit {

  /**
   * Only for locking
   */
  public readonly controlService = inject(ControlService)
  public stepValid = output<boolean>()

  public advice: FormControl = new FormControl<string | null>(null, {
    validators: [Validators.required],
    nonNullable: true
  })

  private readonly declines = false

  private readonly takeUntilDestroyed = getTakeUntilDestroyed()

  get showOptions(): boolean {
    return !this.declines
  }

  constructor() {
    super()
    effect(() => {
      if (this.controlService.declines()) {
        this.advice.setValue(`${this.plrDuNi} avstår från rådgivning`)
        this.staticDataService.followAdvice$.next(this.advice.value)
      } else if (!this.advice.value?.includes('följa mina råd')) {
        this.advice.setValue('')
      }
    })
  }

  public ngOnInit(): void {
    this.staticDataService.followAdvice$
      .pipe(this.takeUntilDestroyed())
      .subscribe((follow: string) => {
        this.advice.setValue(follow)
        this.stepValid.emit(true)
      })
  }

  public approve(event: MatRadioChange): void {
    this.staticDataService.followAdvice$.next(event.value)
    this.stepValid.emit(true)
  }
}
